import Moment from 'react-moment'

type Props = {
    date: string|undefined
}

const DateFormat = ({date}:Props) => {
    try {
        return (
            <Moment format='MMM DD, YYYY'>{date?.indexOf("T") != -1 ? new Date(`${date}`).toISOString() : date}</Moment>
        );
    } catch (err) {
        return (
            <span>{date}</span>
        );
    }
}

export default DateFormat;